import AjaxPromises from '../utils/AjaxPromises';

import { endPoints as EndPoints } from '../constants/AppConstants';

export default {
  employeeLoginDetails: (formData) => AjaxPromises.POST(EndPoints.EMPLOYEE_LOGIN_DETAILS, formData),

  getServerTime: (formData) => AjaxPromises.POST(EndPoints.GET_SERVER_TIME, formData),
};
